import { definePresentationResponse } from "../presenter"

export interface SessionExpiredRequest {
  /** The user whose session expired, to sign in again. */
  readonly username?: string | null
  readonly suppressPasswordManager?: boolean
}

/** Signed in again, or the user chose to sign out instead. */
export type SessionExpiredChoice = "signed-in" | "sign-out"

/**
 * Covers the application after its session expired, so the previous user's content is not readable, and asks
 * to sign in again. It cannot be dismissed: the content stays mounted underneath until the user signs in or
 * signs out.
 */
export const sessionExpiredResponse = definePresentationResponse<SessionExpiredRequest, SessionExpiredChoice>({
  type: "SessionExpired",
})
